export const translations = {
  zh: {
    nav: {
      whatWeDo: '我们的服务',
      insights: '洞见',
      aboutUs: '关于我们',
      insightsSubmenu: {
        title: 'Insights',
        description: '深度洞察家族治理、全球资产配置与跨境生活规划的前沿思考',
        section1: {
          title: '家族治理与传承系列',
          path: '/insights/stewardship'
        },
        section2: {
          title: '全球资产配置前瞻',
          path: '/insights/investment'
        },
        section3: {
          title: '跨境生活与规划',
          path: '/insights/global-citizen'
        },
        section4: {
          title: '创始人对话',
          path: '/insights/founders-forum'
        }
      },
      whatWeDoSubmenu: {
        title: '我们的服务',
        overview: '查看服务总览 →'
      },
      aboutUsSubmenu: {
        title: '关于我们',
        description: '立足香港的离岸顶层架构与专属 OCIO 顾问。我们是谁、为什么是香港、如何合作。',
        whyMurron: '为什么选择昭世',
        whyHongKong: '为什么是香港',
        howWeWork: '合作方式',
        founder: '创始人',
        connectWithUs: '联系我们'
      }
    },
    services: {
      service1: {
        title: '家族宪章与治理体系',
        items: ['家族宪章起草与修订', '家族会议机制设计', '决策流程与权力分配']
      },
      service2: {
        title: '全球资产架构设计',
        items: ['控股结构设计', '税务优化架构', '跨境资产配置']
      },
      service3: {
        title: '投资执行系统',
        items: ['投资政策制定', '资产配置策略', '投资组合管理']
      },
      service4: {
        title: '家族传承规划',
        items: ['代际传承设计', '继承人培养计划', '家族价值观传承']
      },
      service5: {
        title: '家族办公室建设',
        items: ['办公室架构设计', '团队组建与培训', '运营体系搭建']
      }
    },
    insights: {
      insight1: {
        title: '家族治理的三个核心维度',
        date: '2025.01',
        category: '治理体系'
      },
      insight2: {
        title: '全球资产配置的结构化思维',
        date: '2024.12',
        category: '资产架构'
      },
      insight3: {
        title: '二代企业家的身份重塑',
        date: '2024.11',
        category: '传承洞见'
      }
    },
    methodology: {
      governance: '治理',
      structure: '架构',
      continuity: '延续性'
    }
  },
  en: {
    nav: {
      whatWeDo: 'What We Do',
      insights: 'Insights',
      aboutUs: 'About Us',
      insightsSubmenu: {
        title: 'Insights',
        description: 'In-depth perspectives on family governance, global asset allocation, and cross-border living.',
        section1: {
          title: 'The Stewardship Series',
          path: '/insights/stewardship'
        },
        section2: {
          title: 'Global Investment Horizon',
          path: '/insights/investment'
        },
        section3: {
          title: 'The Global Citizen',
          path: '/insights/global-citizen'
        },
        section4: {
          title: "Founder's Forum",
          path: '/insights/founders-forum'
        }
      },
      whatWeDoSubmenu: {
        title: 'What We Do',
        overview: 'View all services →'
      },
      aboutUsSubmenu: {
        title: 'About Us',
        description: 'Hong Kong-based offshore structuring and OCIO advisors. Who we are, why Hong Kong, and how we work.',
        whyMurron: 'Why MuRRÓN',
        whyHongKong: 'Why Hong Kong',
        howWeWork: 'How We Work',
        founder: 'Founder',
        connectWithUs: 'Connect With Us'
      }
    },
    services: {
      service1: {
        title: 'Family Charter & Governance',
        items: ['Family Charter Drafting & Revision', 'Family Council Design', 'Decision-Making & Power Distribution']
      },
      service2: {
        title: 'Global Asset Architecture',
        items: ['Holding Structure Design', 'Tax Optimization Architecture', 'Cross-Border Asset Allocation']
      },
      service3: {
        title: 'Investment Execution System',
        items: ['Investment Policy Development', 'Asset Allocation Strategy', 'Portfolio Management']
      },
      service4: {
        title: 'Family Succession Planning',
        items: ['Generational Succession Design', 'Heir Development Program', 'Family Values Transmission']
      },
      service5: {
        title: 'Family Office Establishment',
        items: ['Office Structure Design', 'Team Building & Training', 'Operations System Setup']
      }
    },
    insights: {
      insight1: {
        title: 'Three Core Dimensions of Family Governance',
        date: 'Jan 2025',
        category: 'Governance'
      },
      insight2: {
        title: 'Structured Thinking in Global Asset Allocation',
        date: 'Dec 2024',
        category: 'Asset Architecture'
      },
      insight3: {
        title: 'Identity Transformation of Second-Generation Entrepreneurs',
        date: 'Nov 2024',
        category: 'Succession'
      }
    },
    methodology: {
      governance: 'Governance',
      structure: 'Structure',
      continuity: 'Continuity'
    }
  }
};


// About Page Translations
translations.zh.about = {
  heroTitle: '关于昭世家族办公室',
  heroSubtitle: 'About MuRRÓN',
  whoWeAreTitle: '昭世家族办公室是谁？',
  whoText1: '昭世家族办公室是一家',
  whoText1Bold: '独立家族办公室咨询机构',
  whoText2: '专注为华人家族提供',
  whoText2Bold: '治理体系、控股架构与跨代资产传承设计',
  whoText3: '我们不销售金融产品，不代理保险或信托，',
  whoText3Bold: '而是作为家族的外部参谋，协助建立结构化的治理能力。',
  whoText4: '我们相信，真正的家族传承，',
  whoText4Bold: '始于清晰的结构、有序的治理、可延续的系统',
  familyTypesTitle: '我们服务的家族',
  familyType1Title: '产业出清家族',
  familyType1Desc: '已完成或正在进行产业转型，需要重新设计资产配置与家族治理结构',
  familyType2Title: '二代 / 三代企业家',
  familyType2Desc: '正在接班或已接班，面临身份重塑与家族系统重建的挑战',
  familyType3Title: '全球化企业家家族',
  familyType3Desc: '资产分布多地，需要跨境架构设计与全球化治理体系',
  valuesTitle: '核心价值观',
  value1Title: 'Order 秩序',
  value1Desc: '建立清晰的治理结构与决策流程，让家族运作有章可循',
  value2Title: 'Clarity 清晰',
  value2Desc: '用结构化思维解决复杂问题，让每个决策都有明确依据',
  value3Title: 'Continuity 延续',
  value3Desc: '设计可以跨越三代的传承系统，让家族价值得以延续',
  founderTitle: '创始人简介',
  founderPhoto: '创始人照片',
  founderName: '创始人姓名',
  founderPosition: 'MuRRÓN 昭世家族办公室创始人 & 首席顾问',
  founderDesc1: '拥有超过十年的家族办公室服务经验，曾为多个华人家族提供治理体系设计与资产架构规划服务。',
  founderDesc2: '专注于家族宪章设计、控股结构优化、跨代传承规划等领域，帮助家族建立清晰、有序、可延续的治理系统。',
  founderDesc3: '持有 [相关资质]，曾在 [机构名称] 担任 [职位]，深度参与多个家族办公室的建设与运营。',
  whyTitle: '为什么选择昭世家族办公室？',
  why1Title: '独立性',
  why1Text: '不销售产品，不收取佣金，完全站在家族立场提供建议',
  why2Title: '专业性',
  why2Text: '深耕家族治理领域，拥有丰富的实战经验',
  why3Title: '系统性',
  why3Text: '提供完整的方法论体系，而非碎片化的咨询服务',
  why4Title: '长期性',
  why4Text: '关注家族的长期发展，而非短期的财务回报'
};

translations.en.about = {
  heroTitle: 'About MuRRÓN',
  heroSubtitle: 'About MuRRÓN FAMILY OFFICE',
  whoWeAreTitle: 'Who We Are',
  whoText1: 'MuRRÓN FAMILY OFFICE is an independent family office consulting firm specializing in providing governance systems, holding structures, and multi-generational wealth succession design for Chinese families.',
  whoText1Bold: '',
  whoText2: 'We do not sell financial products or represent insurance or trusts, but serve as external strategists to help families build structured governance capabilities.',
  whoText2Bold: '',
  whoText3: 'We believe that true family succession begins with clear structures, orderly governance, and sustainable systems.',
  whoText3Bold: '',
  whoText4: '',
  whoText4Bold: '',
  familyTypesTitle: 'Families We Serve',
  familyType1Title: 'Industry Transition Families',
  familyType1Desc: 'Families that have completed or are undergoing industry transformation, requiring redesign of asset allocation and family governance structures',
  familyType2Title: 'Second / Third Generation Entrepreneurs',
  familyType2Desc: 'Those in succession or post-succession, facing challenges of identity transformation and family system reconstruction',
  familyType3Title: 'Global Entrepreneurial Families',
  familyType3Desc: 'Families with assets distributed across multiple jurisdictions, requiring cross-border architecture design and global governance systems',
  valuesTitle: 'Core Values',
  value1Title: 'Order',
  value1Desc: 'Establish clear governance structures and decision-making processes for systematic family operations',
  value2Title: 'Clarity',
  value2Desc: 'Use structured thinking to solve complex problems, ensuring every decision has a clear basis',
  value3Title: 'Continuity',
  value3Desc: 'Design succession systems that can span three generations, preserving family values',
  founderTitle: 'Founder Profile',
  founderPhoto: 'Founder Photo',
  founderName: 'Founder Name',
  founderPosition: 'Founder & Chief Advisor, MuRRÓN FAMILY OFFICE',
  founderDesc1: 'With over a decade of family office service experience, having provided governance system design and asset architecture planning services to multiple Chinese families.',
  founderDesc2: 'Specializes in family charter design, holding structure optimization, and multi-generational succession planning, helping families establish clear, orderly, and sustainable governance systems.',
  founderDesc3: 'Holds [relevant qualifications], previously served as [position] at [institution name], deeply involved in the establishment and operation of multiple family offices.',
  whyTitle: 'Why Choose MuRRÓN?',
  why1Title: 'Independence',
  why1Text: 'No product sales, no commissions, providing advice entirely from the family\'s perspective',
  why2Title: 'Expertise',
  why2Text: 'Deep expertise in family governance with extensive practical experience',
  why3Title: 'Systematic',
  why3Text: 'Providing complete methodology systems, not fragmented consulting services',
  why4Title: 'Long-term',
  why4Text: 'Focusing on long-term family development, not short-term financial returns'
};


// Contact Page Translations
translations.zh.contact = {
  heroTitle: '联系我们',
  heroSubtitle: 'Beyond Contracts, Trusted for Generations.',
  intro: '预约《家族资产底账盘点与税务合规摸底闭门会》：不动钱、不签约，先把家底和税务结构盘清楚。',
  formTitle: '预约闭门会',
  formDesc: '请填写以下信息，我们会在 24 小时内与您联系',
  nameLabel: '姓名 *',
  emailLabel: '邮箱 *',
  companyLabel: '公司 / 家族背景（可选）',
  messageLabel: '咨询内容 *',
  submitButton: '提交预约',
  submitSuccess: '感谢您的咨询，我们会尽快与您联系！',
  submitNotice: '已为您打开邮件客户端，请在邮件中点击发送。若未自动打开，请直接发送邮件至',
  mailSubjectPrefix: '闭门会预约：',
  contactInfoTitle: '联系方式',
  emailTitle: '邮箱',
  wechatTitle: '微信',
  phoneTitle: '电话',
  addressTitle: '办公地址',
  addressValue: '香港中环',
  qrTitle: '微信二维码',
  qrPlaceholder: '微信二维码',
  qrDesc: '扫码添加微信，获取更多信息',
  hoursTitle: '工作时间',
  hoursValue: '周一至周五：9:00 - 18:00\n周六：10:00 - 16:00\n周日及公众假期：休息',
  privacyTitle: '隐私保护',
  privacyText: '我们严格遵守保密协议，您提供的所有信息将被严格保密。我们不会在未经您同意的情况下，向任何第三方披露您的个人信息或家族信息。'
};

translations.en.contact = {
  heroTitle: 'Contact Us',
  heroSubtitle: 'Beyond Contracts, Trusted for Generations.',
  intro: 'Book a closed-door session to map the family balance sheet and tax position. No money moves and nothing is signed.',
  formTitle: 'Book a Closed-Door Session',
  formDesc: 'Please fill in the following information, and we will contact you within 24 hours',
  nameLabel: 'Name *',
  emailLabel: 'Email *',
  companyLabel: 'Company / Family Background (Optional)',
  messageLabel: 'Inquiry *',
  submitButton: 'Submit Request',
  submitSuccess: 'Thank you for your inquiry. We will contact you soon!',
  submitNotice: 'Your email app should now open with your inquiry pre-filled. Please press Send. If it did not open, email us directly at',
  mailSubjectPrefix: 'Closed-door session request: ',
  contactInfoTitle: 'Contact Information',
  emailTitle: 'Email',
  wechatTitle: 'WeChat',
  phoneTitle: 'Phone',
  addressTitle: 'Office Address',
  addressValue: 'Central, Hong Kong',
  qrTitle: 'WeChat QR Code',
  qrPlaceholder: 'WeChat QR Code',
  qrDesc: 'Scan to add WeChat and get more information',
  hoursTitle: 'Business Hours',
  hoursValue: 'Monday - Friday: 9:00 - 18:00\nSaturday: 10:00 - 16:00\nSunday & Public Holidays: Closed',
  privacyTitle: 'Privacy Protection',
  privacyText: 'We strictly adhere to confidentiality agreements. All information you provide will be kept strictly confidential. We will not disclose your personal or family information to any third party without your consent.'
};




// Methodology Page Translations
translations.zh.methodologyPage = {
  heroTitle: '昭世方法论',
  heroSubtitle: 'MuRRÓN Methodology',
  intro: '结构先于投资：先把最坏情况兜住，再谈增长。',
  triangleTitle: '三维治理模型',
  triangleDesc: '昭世方法论基于三个核心维度构建家族治理体系',
  governanceTitle: 'Governance 治理',
  governanceDesc: '建立清晰的决策机制、权力分配与冲突解决体系，确保家族运作有序、决策高效',
  structureTitle: 'Structure 架构',
  structureDesc: '设计税务优化、风险隔离、传承便利的全球资产架构，保护家族财富安全',
  continuityTitle: 'Continuity 延续性',
  continuityDesc: '规划代际传承路径、培养继承人、传承家族价值观，确保家族基业长青',
  phasesTitle: '四阶段工作流程',
  principlesTitle: '六项工作原则',
  ctaTitle: '了解昭世方法论如何应用于您的家族',
  ctaText: '先约一场闭门会，把家底和税务结构摸个底：不动钱、不签约。',
  ctaButton: '预约闭门会',
  phases: [
    {
      number: '01',
      title: '诊断阶段',
      subtitle: 'Diagnosis',
      description: '资产排雷与税务结构摸底：在不挪动一分钱的前提下盘清散落全球的家底，重构合规的家办税务架构',
      duration: '2-4 周'
    },
    {
      number: '02',
      title: '设计阶段',
      subtitle: 'Design',
      description: '制定治理架构、资产结构与传承方案的完整设计',
      duration: '4-8 周'
    },
    {
      number: '03',
      title: '实施阶段',
      subtitle: 'Implementation',
      description: '协助落地执行，包括法律文件、架构搭建与流程建立',
      duration: '8-16 周'
    },
    {
      number: '04',
      title: '优化阶段',
      subtitle: 'Optimization',
      description: '持续跟踪、评估与优化，确保系统有效运作',
      duration: '长期'
    }
  ],
  principles: [
    { title: '独立性', description: '不销售产品，不收取佣金，完全站在家族立场' },
    { title: '系统性', description: '提供完整的方法论体系，而非碎片化咨询' },
    { title: '定制化', description: '每个家族都有独特的方案，没有标准模板' },
    { title: '长期性', description: '关注家族的长期发展，而非短期财务回报' },
    { title: '保密性', description: '严格的保密协议，保护家族隐私与敏感信息' },
    { title: '专业性', description: '深耕家族治理领域，拥有丰富的实战经验' }
  ]
};

translations.en.methodologyPage = {
  heroTitle: 'MuRRÓN Methodology',
  heroSubtitle: 'Our Approach',
  intro: 'Structure before investment: secure the worst case first, then talk about growth.',
  triangleTitle: 'Three-Dimensional Governance Model',
  triangleDesc: 'The MuRRÓN methodology builds family governance systems on three core dimensions',
  governanceTitle: 'Governance',
  governanceDesc: 'Establish clear decision-making mechanisms, power distribution, and conflict resolution systems to ensure orderly family operations and efficient decision-making',
  structureTitle: 'Structure',
  structureDesc: 'Design global asset architectures optimized for tax efficiency, risk isolation, and succession convenience to protect family wealth',
  continuityTitle: 'Continuity',
  continuityDesc: 'Plan generational succession pathways, cultivate heirs, and transmit family values to ensure lasting family legacy',
  phasesTitle: 'Four-Phase Workflow',
  principlesTitle: 'Six Working Principles',
  ctaTitle: 'Learn How the MuRRÓN Methodology Can Apply to Your Family',
  ctaText: 'Start with a closed-door session to map the family balance sheet and tax position. No money moves and nothing is signed.',
  ctaButton: 'Book a closed-door session',
  phases: [
    {
      number: '01',
      title: 'Diagnosis Phase',
      subtitle: 'Diagnosis',
      description: 'Asset mapping and tax-structure review: without moving a single dollar, inventory the family balance sheet worldwide and rebuild a compliant family office tax structure',
      duration: '2-4 weeks'
    },
    {
      number: '02',
      title: 'Design Phase',
      subtitle: 'Design',
      description: 'Develop comprehensive designs for governance architecture, asset structure, and succession plans',
      duration: '4-8 weeks'
    },
    {
      number: '03',
      title: 'Implementation Phase',
      subtitle: 'Implementation',
      description: 'Assist with execution, including legal documents, structure setup, and process establishment',
      duration: '8-16 weeks'
    },
    {
      number: '04',
      title: 'Optimization Phase',
      subtitle: 'Optimization',
      description: 'Continuous tracking, evaluation, and optimization to ensure effective system operation',
      duration: 'Long-term'
    }
  ],
  principles: [
    { title: 'Independence', description: 'No product sales, no commissions, entirely from the family\'s perspective' },
    { title: 'Systematic', description: 'Complete methodology system, not fragmented consulting' },
    { title: 'Customized', description: 'Each family has a unique solution, no standard templates' },
    { title: 'Long-term', description: 'Focus on long-term family development, not short-term financial returns' },
    { title: 'Confidential', description: 'Strict confidentiality agreements to protect family privacy and sensitive information' },
    { title: 'Professional', description: 'Deep expertise in family governance with extensive practical experience' }
  ]
};

// Insights Page Translations
translations.zh.insightsPage = {
  heroTitle: '洞见',
  heroSubtitle: 'Insights',
  intro: '关于家族治理、资产架构与传承的深度思考',
  allCategory: '全部',
  governanceCategory: '治理体系',
  structureCategory: '资产架构',
  legacyCategory: '传承洞见',
  investmentCategory: '投资策略',
  newsletterTitle: '订阅洞见',
  newsletterText: '定期接收关于家族治理与传承的深度文章',
  newsletterPlaceholder: '您的邮箱地址',
  newsletterButton: '订阅',
  readTime: '分钟'
};

translations.en.insightsPage = {
  heroTitle: 'Insights',
  heroSubtitle: 'Insights',
  intro: 'In-depth thinking on family governance, asset architecture, and succession',
  allCategory: 'All',
  governanceCategory: 'Governance',
  structureCategory: 'Asset Architecture',
  legacyCategory: 'Succession',
  investmentCategory: 'Investment Strategy',
  newsletterTitle: 'Subscribe to Insights',
  newsletterText: 'Receive in-depth articles on family governance and succession regularly',
  newsletterPlaceholder: 'Your email address',
  newsletterButton: 'Subscribe',
  readTime: 'min read'
};
